module.exports = __webpack_public_path__ + "img/ch8pic2a.c6d83d99.png";